/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on the Post Type Archive Product page
    // debounce so filtering doesn't happen every millisecond
    function debounce( fn, threshold ) {
      let timeout;
      return function debounced() {
        if ( timeout ) {
          clearTimeout( timeout );
        }
        function delayed() {
          fn();
          timeout = null;
        }
        timeout = setTimeout( delayed, threshold || 100 );
      };
    }

    // quick search regex
    let qsRegex;

    // Remove .selected option from category dropdown
    $('.product-landing__filter-show, .product-landing__filter-by, .product-landing__filter-sort').on( 'show.bs.select', function(e) {
      $(this).find('li.selected').addClass('hidden');
    });

    // Add previously .selected option back in
    $('.product-landing__filter-show, .product-landing__filter-by, .product-landing__filter-sort').on( 'hidden.bs.select', function(e) {
      $(this).find('li.hidden').removeClass('hidden');
    });

    function uniq(a) {
      const seen = {};
      return a.filter(item => seen.hasOwnProperty(item) ? false : (seen[item] = true));
    }

    function addItems(className, taxonomyArray, taxName) {
      // Remove all options, add "*" option
      $(className).find('option').remove().end();
      $(className).append('<option value="*">All Uses</option>');
      $(className).selectpicker('refresh');

      // Add options for clickedVal
      taxonomyArray.forEach((e, i) => {
        const tempArray = e.split(",");
        if (products.userRole == 'pro') {
          if (tempArray[1] == 'medical-license-required' && parseInt(products.hasValidMedicalLicense)) {
            $(className).append(`<option data-filter-show="${taxName}" value=".${tempArray[1]}">${tempArray[0]}</option>`);
          } else if (tempArray[1] == 'professional-only' && parseInt(products.hasResaleCertificate)) {
            $(className).append(`<option dxData-filter-show="${taxName}" value=".${tempArray[1]}">${tempArray[0]}</option>`);
          } else if (tempArray[1] !== 'medical-license-required' && tempArray[1] !== 'professional-only') {
            $(className).append(`<option dxData-filter-show="${taxName}" value=".${tempArray[1]}">${tempArray[0]}</option>`);
          }
        } else {
          if ((tempArray[1] !== 'professional-only') && (tempArray[1] !== 'medical-license-required')) {
            $(className).append(`<option data-filter-show="${taxName}" value=".${tempArray[1]}">${tempArray[0]}</option>`);
          }
        }
      });

      // refresh after adding options
      $(className).selectpicker('refresh');
    }

    function addAllItems(className, taxonomiesObj, taxName) {
      // Remove all options, add "*" option
      $(className).find('option').remove().end();
      $(className).append('<option value="*">All Uses</option>');
      $(className).selectpicker('refresh');

      // Add options for clickedVal
      for (const prop in taxonomiesObj) {
        if (taxonomiesObj.hasOwnProperty(prop)) {
          taxonomiesObj[prop].forEach((e, i) => {
            const tempArray = e.split(",");
            if (products.userRole == 'pro') {
              if (tempArray[1] == 'medical-license-required' && parseInt(products.hasValidMedicalLicense)) {
                $(className).append(`<option data-filter-show="all" value=".${tempArray[1]}">${tempArray[0]}</option>`);
              } else if (tempArray[1] == 'professional-only' && parseInt(products.hasResaleCertificate)) {
                $(className).append(`<option dxData-filter-show="${taxName}" value=".${tempArray[1]}">${tempArray[0]}</option>`);
              } else if (tempArray[1] !== 'medical-license-required' && tempArray[1] !== 'professional-only') {
                $(className).append(`<option dxData-filter-show="${taxName}" value=".${tempArray[1]}">${tempArray[0]}</option>`);
              }
            } else {
              if ((tempArray[1] !== 'professional-only') && (tempArray[1] !== 'medical-license-required')) {
                $(className).append(`<option data-filter-show="all" value=".${tempArray[1]}">${tempArray[0]}</option>`);
              }
            }
          });
        }
      }

      // refresh after adding options
      $(className).selectpicker('refresh');
    }

    let concern = [];
    let category = [];
    let skin = [];
    $(".product-landing__post-data").each((i, e) => {
      const a = $(e).attr("data-concern").split('|');
      const b = $(e).attr("data-category");
      const c = $(e).attr("data-skin").split('|');
      
      if (typeof a !== 'undefined' && a !== 'Uncategorized' &&  a !== '' && !concern.includes(a)) {
        concern.push(...a);
        // console.log(`a - ${i}: `, a);
        
      }

      if (typeof b !== 'undefined' && b !== 'Uncategorized' && b !== '' && !category.includes(b)) {
        category.push(b);
        // console.log(`b - ${i}: `, b);
      }

      if (typeof c !== 'undefined' && c !== 'Uncategorized' &&  c !== '' && !skin.includes(c)) {
        skin.push(...c);
        // console.log(`c - ${i}: `, c);
      }
    });
    // console.log('concern: ', concern);
    // console.log('category: ', category);
    // console.log('skin: ', skin);

    Array.prototype.clean = function(deleteValue) {
      for (let i = 0; i < this.length; i++) {
        if (this[i] == deleteValue) {
          this.splice(i, 1);
          i--;
        }
      }
      return this;
    };

    concern = Array.from(new Set(concern)).clean("");
    category = $.unique(category);
    skin = Array.from(new Set(skin)).clean("");

    // structure our data so it's easy to navigate
    const dataObj = {
      concern,
      category,
      skin
    };

    // console.log('dataObj: ', dataObj);

    // add options for clickedVal to the DOM
    $('.product-landing__filter-show').on( 'changed.bs.select', function(e, clickedIndex, newValue, oldValue) {
      const clickedVal = $(this).find('option').eq(clickedIndex).val();
      if (clickedVal === 'all') {
        addAllItems('#product-landing__filter-by', dataObj, clickedVal);
        $grid.isotope({
          filter() {
            const $this = $(this);

            // first get the value of the topic filter
            const dropdownVal = $('#product-landing__filter-by').find('option:selected').val();

            // factor the value into the search filter
            const matchedText = dropdownVal ? $this.is( dropdownVal ) : true;

            const searchResult = qsRegex ? $this.text().match( qsRegex ) : true;

            return searchResult && matchedText;
          }
        });
      } else {
        addItems('#product-landing__filter-by', dataObj[clickedVal], clickedVal);
      }
    });

    // use value of search field to filter
    var $quicksearch = $('.quicksearch').keyup( debounce( () => {
      qsRegex = new RegExp( $quicksearch.val(), 'gi' );
      $grid.isotope();
    }, 200 ) );

    // init Isotope
    var $grid = $('.product-landing__grid').isotope({
      itemSelector: '.product-landing__post',
      layoutMode: 'fitRows',
      initLayout: true,
      getSortData: {
        alphabetically: '.product-landing__post-title',
      },
      filter() {
        const $this = $(this);

        // first get the value of the topic filter
        const dropdownVal = $('#product-landing__filter-by').find('option:selected').val();

        const sortVal = $('.product-landing__filter-sort').find('option:selected').val();

        // factor the value into the search filter
        const matchedText = dropdownVal ? $this.is( dropdownVal ) : true;

        const searchResult = qsRegex ? $this.text().match( qsRegex ) : true;

        return searchResult && matchedText;
      }
    });

    $('.product-landing__filter-sort').on('changed.bs.select', function(e, clickedIndex, newValue, oldValue) {
      const sortVal = $(this).find('option').eq(clickedIndex).val();
      $grid.isotope({ sortBy: sortVal });
    });

    // first get the value of the topic filter
    $('.product-landing__filter-by').on( 'changed.bs.select', function(e, clickedIndex, newValue, oldValue) {
      const dropdownVal = $(this).find('option').eq(clickedIndex).val();
      $grid.isotope({
        filter() {
          const $this = $(this);

          // first get the value of the topic filter
          const dropdownVal = $('#product-landing__filter-by').find('option:selected').val();

          // factor the value into the search filter
          const matchedText = dropdownVal ? $this.is( dropdownVal ) : true;

          const searchResult = qsRegex ? $this.text().match( qsRegex ) : true;

          return searchResult && matchedText;
        }
      });
    });

    const $noPosts = $('.product-landing__filter-search').keyup( debounce( () => {
      const numPosts = $grid.data('isotope').filteredItems.length;
      if (numPosts >= 1) {
        $('#msg-box').css({"opacity":"0", "height":"0", "padding":"0"});
      } else {
        $('#msg-box').css({"opacity":"1", "height":"auto", "padding":"60px 0"});
      }

      const userInput = $('.product-landing__filter-search').val();
      $('.product-landing__no-results--user-input').html(userInput);
    }, 250 ) );

    // use value of search field to filter
    var $quicksearch = $('.quicksearch').keyup( debounce( () => {
      qsRegex = new RegExp( $quicksearch.val(), 'gi' );
      $grid.isotope();
    }, 200 ) );

    // bind event
    $grid.isotope( 'on', 'arrangeComplete', () => {
      // matchHeight.js
      $('.product-landing__post-content-wrapper').matchHeight({
        byRow: false
      });
    });
    // manually trigger initial layout
    $grid.isotope();
  },
  finalize() {
    // JavaScript to be fired on the Post Type Archive Product page, after the init JS

    $('.product-landing__post-content-wrapper').matchHeight({
      byRow: false
    });

    // debounce so filtering doesn't happen every millisecond
    function debounce( fn, threshold ) {
      let timeout;
      return function debounced() {
        if ( timeout ) {
          clearTimeout( timeout );
        }
        function delayed() {
          fn();
          timeout = null;
        }
        timeout = setTimeout( delayed, threshold || 100 );
      };
    }
    // quick search regex
    let qsRegex;

    // use value of search field to filter
    const $quicksearch = $('.quicksearch').keyup( debounce( () => {
      qsRegex = new RegExp( $quicksearch.val(), 'gi' );
      $grid.isotope();
    }, 200 ) );

    // init Isotope
    var $grid = $('.product-landing__grid').isotope({
      itemSelector: '.product-landing__post',
      layoutMode: 'fitRows',
      initLayout: true,
      getSortData: {
        alphabetically: '.product-landing__post-title',
      },
      filter() {
        const $this = $(this);

        // first get the value of the topic filter
        const dropdownVal = $('#product-landing__filter-by').find('option:selected').val();

        // factor the value into the search filter
        const matchedText = dropdownVal ? $this.is( dropdownVal ) : true;

        const searchResult = qsRegex ? $this.text().match( qsRegex ) : true;

        return searchResult && matchedText;
      }
    });

    // add the logic for filtering on URL hashes
    if (window.location.href.includes('#')) {
      const hashVal = window.location.href.split('#')[1];
      // console.log('hashVal: ', hashVal);
      $('#product-landing__filter-by').val(`.${hashVal}`);
      $('#product-landing__filter-by').find(`[value=".${hashVal}"]`).prop('selected',true);
      $('#product-landing__filter-by').selectpicker('refresh');
      $('.product-landing__filter-by').trigger('changed.bs.select');
    }

    // // add the event handler for the Quickview buttons
    // $('[id^="quickview-button_"]').on('click', e => {
    //   e.preventDefault();
    //   e.stopPropagation();
    //   const target = e.target || e.srcElement;
    //   const productId = $(target).attr('id').split('_')[1];
    //   const $modal = $('#quickviewModal');

    //   // update the value of the data-product-id attr on the modal
    //   $modal.attr('data-product-id', productId);

    //   // hide the modal content and show loader
    //   $modal.find('.product-detail__wrapper--quickview-modal').addClass('hidden').before('<div style="text-align:center;"><i id="productModalLoader" class="far fa-spinner fa-pulse fa-4x"></i></div>');

    //   // show the modal
    //   $('#quickviewModal').modal({"show":true});
    // });

    // // event handler for the modal show event
    // $('#quickviewModal').on('show.bs.modal',e => {
    //   const modal = e.target || e.srcElement;
    //   const productId = $(modal).attr('data-product-id');
    //   const jsonData = {
    //     productId
    //   };

    //   // perform an AJAX request to get the products info
    //   const $promise = $.ajax({
    //     url: products.ajaxUrl,
    //     method: 'post',
    //     dataType: 'json',
    //     data: {'json': jsonData, 'security': products.nonce, 'action': 'getProductDetails'}
    //   });

    //   $promise.done((response, textStatus, jqXhr) => {
    //     const productModalClasses = {
    //       flagContainer: 'product-detail__status',
    //       image: 'product-detail__image--quickview-modal',
    //       title: 'product-detail__title--quickview-modal',
    //       size: 'product-detail__details__size',
    //       priceContainer: 'product-detail__details__price--quickview-modal',
    //       shopActionsContainer: 'product-detail__details__shop-actions.quickview-modal',
    //       addToBagContainer: 'product-detail__details__shop-actions__add-to-bag--quickview-modal',
    //       buyNowContainer: 'product-detail__details__shop-actions__buy-now--quickview-modal',
    //       description: 'product-detail__details__description',
    //       viewAllDetailsLink: 'product-detail__details__shop-actions__view-all-details__link--quickview-modal'
    //     };

    //     let badgeCount = 0;
    //     let newFlag;
    //     if (response.data.isNew) {
    //       newFlag = `<span id="quickview-badge-${badgeCount}" class="product-detail__status--new"></span>`;
    //       badgeCount++;
    //     } else {
    //       newFlag = '';
    //     }
    //     let soldOutFlag;
    //     if (!response.data.isInStock) {
    //       soldOutFlag = `<span id="quickview-badge-${badgeCount}" class="product-detail__status--sold-out"></span>`;
    //       badgeCount++;
    //     } else {
    //       soldOutFlag = '';
    //     }
    //     /**
    //      * Comment out pro pricing 2020-10-22 per Trish's request
    //      */
    //     if (products.userRole === 'pro') {
    //       // show the pro pricing table
    //       // $('.product-detail__details__pro-pricing-table-container').removeClass('hidden');

    //       // var regularPrice = `<span class="regular-price" data-original-price="${response.data.regularPrice}">$${(parseFloat(response.data.regularPrice)-(parseFloat(response.data.regularPrice)*0.50)).toFixed(2)}</span>`;

    //       // // populate the pro pricing table with regular price tier data
    //       // $('#pro-price-tier-1').html(`$${(response.data.regularPrice-(response.data.regularPrice*0.50)).toFixed(2)}`);
    //       // $('#pro-price-tier-2').html(`$${(response.data.regularPrice-(response.data.regularPrice*0.55)).toFixed(2)}`);
    //       // $('#pro-price-tier-3').html(`$${(response.data.regularPrice-(response.data.regularPrice*0.575)).toFixed(2)}`);
    //       // var saleFlag;
    //       // var salePrice = '';
    //       // if (response.data.isOnSale) {
    //       //   saleFlag = `<span id="quickview-badge-${badgeCount}" class="span product-detail__status--sale"></span>`;
    //       //   salePrice = `<span class="sale-price" data-original-price="${response.data.salePrice}">$${(parseFloat(response.data.salePrice)-(parseFloat(response.data.salePrice)*0.50)).toFixed(2)}</span>`;

    //       //   // populate the pro pricing table with sale price tier data
    //       //   $('#pro-price-tier-1').html(`$${(response.data.salePrice-(response.data.salePrice*0.50)).toFixed(2)}`);
    //       //   $('#pro-price-tier-2').html(`$${(response.data.salePrice-(response.data.salePrice*0.55)).toFixed(2)}`);
    //       //   $('#pro-price-tier-3').html(`$${(response.data.salePrice-(response.data.salePrice*0.575)).toFixed(2)}`);
    //       // } else {
    //       //   saleFlag = '';
    //       //   salePrice = '';
    //       // }
    //     } else {
    //       var regularPrice = `<span class="regular-price" data-original-price="${response.data.regularPrice}">$${response.data.regularPrice}</span>`;
    //       var saleFlag;
    //       var salePrice = '';
    //       if (response.data.isOnSale) {
    //         saleFlag = `<span id="quickview-badge-${badgeCount}" class="span product-detail__status--sale"></span>`;
    //         salePrice = `<span class="sale-price" data-original-price="${response.data.salePrice}">$${response.data.salePrice}</span>`;
    //         badgeCount++;
    //       } else {
    //         saleFlag = '';
    //         salePrice = '';
    //       }
    //     }

    //     // Quantity select reset
    //     $('#number-spinner-input').val(1);

    //     const addToBagButton = `<a href="#" class="product-detail__details__shop-actions__add-to-bag__btn" data-product-id="${response.data.productId}">Add to Bag</a>`;
    //     const buyNowButton = `<a href="${response.data.buyNowUrl}" class="product-detail__details__shop-actions__buy-now__btn">Buy Now</a>`;

    //     // append the status flags
    //     $(`.${productModalClasses.flagContainer}`).html('');
    //     $(`.${productModalClasses.flagContainer}`).append(newFlag);
    //     $(`.${productModalClasses.flagContainer}`).append(saleFlag);
    //     $(`.${productModalClasses.flagContainer}`).append(soldOutFlag);


    //     // append the product image
    //     $(`.${productModalClasses.image}`).html('');
    //     $(`.${productModalClasses.image}`).append(response.data.productImage);

    //     // append product title
    //     $(`.${productModalClasses.title}`).html(response.data.productTitle);

    //     // append product size
    //     $(`.${productModalClasses.size}`).html('');
    //     $(`.${productModalClasses.size}`).append(response.data.productSize);

    //     // append the product pricing
    //     $(`.${productModalClasses.priceContainer}`).html('');
    //     $(`.${productModalClasses.priceContainer}`).append(salePrice);
    //     $(`.${productModalClasses.priceContainer}`).append(regularPrice);
    //     $(`.${productModalClasses.priceContainer}`).attr("data-original-regular-price",response.data.regularPrice);
    //     $(`.${productModalClasses.priceContainer}`).attr("data-original-sale-price",response.data.salePrice);

    //     // append the variable pricing dropdown
    //     if ($('.product-detail__details__shop-actions__variation--quickview-modal').length){
    //       $('.product-detail__details__shop-actions__variation--quickview-modal').remove();
    //     }
    //     $(`.${productModalClasses.shopActionsContainer}`).prepend(response.data.productVariationDropdown);

    //     /**
    //      * Hide addToBag and buyNowButton for pros 2020-10-22 per Trish's request
    //      */
    //     if (products.userRole != 'pro') {
    //       // append the CTA buttons (Add to Bag & Buy Now)

    //       if (response.data.isInStock) {
    //         $(`.${productModalClasses.addToBagContainer}`).html('');
    //         $(`.${productModalClasses.addToBagContainer}`).append(addToBagButton);
    //         $(`.${productModalClasses.buyNowContainer}`).html('');
    //         $(`.${productModalClasses.buyNowContainer}`).append(buyNowButton);
    //       } else {
    //         $('.product-detail__details__shop-actions__quantity').remove()
    //         $(`.${productModalClasses.addToBagContainer}`).html('');
    //         $(`.${productModalClasses.buyNowContainer}`).html('');
    //       }
    //     } else {
    //       $(`.${productModalClasses.description}`).after('<div class="alert alert-info" role="alert"><i class="fas fa-info-circle"></i> Please contact your Epionce representative for wholesale ordering.</div>');
    //       $('.product-detail__details__shop-actions__quantity').remove()
    //       $(`.${productModalClasses.addToBagContainer}`).html('');
    //       $(`.${productModalClasses.buyNowContainer}`).html('');
    //     }

    //     // append the description
    //     if (response.data.isInStock) {
    //       $(`.${productModalClasses.description}`).html(response.data.productDescription);
    //     } else {
    //       $(`.${productModalClasses.description}`).html(response.data.productDescription + '<br><h3 class="text-primary h5">Out of stock.</h3>');
    //     }

    //     // add the product detail page link
    //     $(`.${productModalClasses.viewAllDetailsLink}`).attr('href',response.data.productUrl);

    //     // remove loader and show the modal content
    //     $('#quickviewModal').find('.product-detail__wrapper--quickview-modal').removeClass('hidden');

    //     // if it's a pro wholesale user, remove the hidden class on the pro pricing table
    //     $('#productModalLoader').remove();

    //     // position the flags, if they are present
    //     const paddingLeft = 5;
    //     for (let i = 0; i <= badgeCount; i++) {
    //       if ( i === 0 ) {
    //         $(`#quickview-badge-${i}`).css({'top':'-1px', 'left':'15px'});
    //       } else {
    //         const prevLeft = parseInt($(`#quickview-badge-${i-1}`).css('left'));
    //         const prevWidth = parseInt($(`#quickview-badge-${i-1}`).outerWidth());
    //         $(`#quickview-badge-${i}`).css({'top':'-1px', 'left':`${prevLeft+prevWidth+paddingLeft}px;`, 'margin-right':'5px'});
    //       }
    //     }

    //     // See if there are variations and update links
    //     if ($('.product-detail__details__shop-actions__variation__select').length > 0) {
    //       const target = e.target || e.srcElement;
    //       const variationSelect = $(target);
    //       const selectedOption = variationSelect.find(':selected');
    //       const productId = variationSelect.attr('data-product-id');
    //       const variationId = selectedOption.val();
    //       const variationValue = selectedOption.attr('data-variation-encoded');
    //       const quantity = $('#number-spinner-input').val();

    //       // update the add to bag and buy now button urls dynamically
    //       $('.product-detail__details__shop-actions__add-to-bag__btn').attr('href',`/?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
    //       $('.product-detail__details__shop-actions__buy-now__btn').attr('href',`/shopping-bag/?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
    //     }
    //   });

    //   $promise.fail((jqXhr, textStatus, errorThrown) => {
    //     // console.log(jqXhr);
    //     // console.log(textStatus);
    //     // console.log(errorThrown);
    //   });
    // });

    // // event handler for qty +/- button presses
    // $('#number-spinner-input').on('change', function(e){
    //   const quantity = $('#number-spinner-input').val();
    //   const productId = $('.product-detail__details__shop-actions__add-to-bag__btn').attr('data-product-id');
      
    //   if ($('.product-detail__details__shop-actions__variation__select').length > 0) {
    //     const variationSelect = $('.product-detail__details__shop-actions__variation__select');
    //     const selectedOption = variationSelect.find(':selected');
    //     const variationId = selectedOption.val();
    //     const variationValue = selectedOption.attr('data-variation-encoded');

    //     // update the add to bag and buy now button urls dynamically
    //     $('.product-detail__details__shop-actions__add-to-bag__btn').attr('href',`/?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
    //     $('.product-detail__details__shop-actions__buy-now__btn').attr('href',`/shopping-bag/?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
    //   } else {
    //     // update the add to bag and buy now button urls dynamically
    //     $('.product-detail__details__shop-actions__add-to-bag__btn').attr('href',`/?add-to-cart=${productId}&quantity=${quantity}`);
    //     $('.product-detail__details__shop-actions__buy-now__btn').attr('href',`/shopping-bag/?add-to-cart=${productId}&quantity=${quantity}`);
    //   }

    //   if (products.userRole === 'pro') {
    //     // wholesale pricing, which is the only pricing affected by qty changes
    //     if ($('.product-detail__details__shop-actions__variation__select').length) {
    //       // for products that have variations
    //       const variationSelect = $('.product-detail__details__shop-actions__variation__select');
    //       var isSale = variationSelect.attr('data-is-sale');
    //       const selectedOption = variationSelect.find(':selected');
    //       const variationValue = selectedOption.attr('data-variation-encoded');
    //       var regularPrice = parseFloat(selectedOption.attr('data-regular-price').substr(1));
    //       var salePrice = parseFloat(selectedOption.attr('data-price').substr(1));
    //       var qty = parseInt($(this).val());
    //       if (qty > 0 && qty < 12) {
    //         var proRegularPrice = (regularPrice-(regularPrice*0.50)).toFixed(2);
    //         var proSalePrice = (salePrice-(salePrice*0.50)).toFixed(2);
    //       } else if ((qty > 11) && (qty < 60)) {
    //         var proRegularPrice = (regularPrice-(regularPrice*0.55)).toFixed(2);
    //         var proSalePrice = (salePrice-(salePrice*0.55)).toFixed(2);
    //       } else {
    //         // greater than 60
    //         var proRegularPrice = (regularPrice-(regularPrice*0.575)).toFixed(2);
    //         var proSalePrice = (salePrice-(salePrice*0.575)).toFixed(2);
    //       }

    //       if (isSale === 'true') {
    //         $('.product-detail__details__price--quickview-modal').find('.sale-price').text(`$${proSalePrice}`);
    //       } else {
    //         $('.product-detail__details__price--quickview-modal').find('.regular-price').text(`$${proRegularPrice}`);
    //       }
    //     } else {
    //       // no variations for this product
    //       var regularPrice = parseFloat($('.product-detail__details__price--quickview-modal').attr("data-original-regular-price"));
    //       var salePrice = parseFloat($('.product-detail__details__price--quickview-modal').attr("data-original-sale-price"));
    //       var qty = $(this).val();
    //       if (qty > 0 && qty < 12) {
    //         var proRegularPrice = (regularPrice-(regularPrice*0.50)).toFixed(2);
    //         var proSalePrice = (salePrice-(salePrice*0.50)).toFixed(2);
    //       } else if ((11 < qty) && (qty < 60)) {
    //         var proRegularPrice = (regularPrice-(regularPrice*0.55)).toFixed(2);
    //         var proSalePrice = (salePrice-(salePrice*0.55)).toFixed(2);
    //       } else {
    //         // greater than 60
    //         var proRegularPrice = (regularPrice-(regularPrice*0.575)).toFixed(2);
    //         var proSalePrice = (salePrice-(salePrice*0.575)).toFixed(2);
    //       }

    //       if (isSale === 'true') {
    //         $('.product-detail__details__price--quickview-modal').find('.sale-price').text(`$${proSalePrice}`);
    //       } else {
    //         $('.product-detail__details__price--quickview-modal').find('.regular-price').text(`$${proRegularPrice}`);
    //       }
    //     }
    //   }
    // });

    // // event handler for qty input field changes
    // $('.product-detail__details__shop-actions__quantity__number-spinner').on('click','.input-group-btn',e => {
    //   $('#number-spinner-input').trigger('change');
    // });

    // // event handler for variation select dropdown changes
    // $('.product-detail__details__shop-actions.quickview-modal').on('change', '.product-detail__details__shop-actions__variation--quickview-modal', e => {
    //   const target = e.target || e.srcElement;
    //   const variationSelect = $(target);
    //   const isSale = variationSelect.attr('data-is-sale');
    //   const selectedOption = variationSelect.find(':selected');
    //   const productId = $('.product-detail__details__shop-actions__add-to-bag__btn').attr('data-product-id');
    //   const quantity = $('#number-spinner-input').val();
    //   const variationId = selectedOption.val();
    //   const variationValue = selectedOption.attr('data-variation-encoded');
    //   const regularPrice = parseFloat(selectedOption.attr('data-regular-price').substr(1));
    //   const salePrice = parseFloat(selectedOption.attr('data-price').substr(1));

    //   const regularPriceTier1 = regularPrice-(regularPrice*0.50);
    //   const regularPriceTier2 = regularPrice-(regularPrice*0.55);
    //   const regularPriceTier3 = regularPrice-(regularPrice*0.575);

    //   const salePriceTier1 = salePrice-(salePrice*0.575);
    //   const salePriceTier2 = salePrice-(salePrice*0.575);
    //   const salePriceTier3 = salePrice-(salePrice*0.575);

    //   if (products.userRole === 'pro') {
    //     const qty = parseFloat($('#number-spinner-input').val());
    //     if (qty == 0 || ((qty > 0) && (qty < 12))) {
    //       var proRegularPriceMain = (regularPrice-(regularPrice*0.50));
    //       var proSalePriceMain = (salePrice-(salePrice*0.50));
    //     } else if ((qty > 11) && (qty < 60)) {
    //       var proRegularPriceMain = (regularPrice-(regularPrice*0.55));
    //       var proSalePriceMain = (salePrice-(salePrice*0.55));
    //     } else {
    //       // qty > 59
    //       var proRegularPriceMain = (regularPrice-(regularPrice*0.575));
    //       var proSalePriceMain = (salePrice-(salePrice*0.575));
    //     }

    //     if (isSale === 'true') {
    //       $('.sale-price').text(`$${proSalePriceMain.toFixed(2)}`);
    //       $('.regular-price').text(`$${proRegularPriceMain.toFixed(2)}`);

    //       // apply the price tiers to the price tier table
    //       $('#pro-price-tier-1').html(`$${salePriceTier1.toFixed(2)}`);
    //       $('#pro-price-tier-2').html(`$${salePriceTier2.toFixed(2)}`);
    //       $('#pro-price-tier-3').html(`$${salePriceTier3.toFixed(2)}`);
    //     } else {
    //       $('.regular-price').text(`$${proRegularPriceMain.toFixed(2)}`);

    //       // apply the price tiers to the price tier table
    //       $('#pro-price-tier-1').html(`$${regularPriceTier1.toFixed(2)}`);
    //       $('#pro-price-tier-2').html(`$${regularPriceTier2.toFixed(2)}`);
    //       $('#pro-price-tier-3').html(`$${regularPriceTier3.toFixed(2)}`);
    //     }
    //   } else {
    //     // end user pricing
    //     if (isSale === 'true') {
    //       $('.sale-price').text(`$${salePrice.toFixed(2)}`);
    //       $('.regular-price').text(`$${regularPrice.toFixed(2)}`);
    //     } else {
    //       $('.regular-price').text(`$${regularPrice.toFixed(2)}`);
    //     }
    //   }

    //   // update the add to bag and buy now button urls dynamically
    //   $('.product-detail__details__shop-actions__add-to-bag__btn').attr('href',`/?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
    //   $('.product-detail__details__shop-actions__buy-now__btn').attr('href',`/shopping-bag/?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
    // });

    // // event handler for the Add to Bag button click
    // $('#quickviewModal').on('click', '.product-detail__details__shop-actions__add-to-bag__btn', e => {
    //   e.preventDefault();
    //   const target = e.target || e.srcElement;
    //   const variationSelect = $('.product-detail__details__shop-actions__variation__select');
    //   const selectedOption = variationSelect.find(':selected');
    //   var variationId = null;
    //   var variations = [];

    //   if (variationSelect.length > 0) {
    //     var variationId = selectedOption.val();
    //     var variations = {
    //       'Size': selectedOption.text()
    //     };
    //   };

    //   const jsonData = {
    //     'productId': $(target).attr('data-product-id'),
    //     'quantity': $('#quickviewModal #number-spinner-input').val(),
    //     'variationId': variationId,
    //     'variation': variations
    //   };

    //   if (products.userRole == 'pro') {
    //     // wholesale customer, temporarily deny Add to Bag functionality
    //     $('#wholesale-notification-modal').modal('show');
    //   } else {
    //     // regular customer, allow AJAX Add to Bag functionality
    //     $(target).html('<i class="far fa-spinner fa-pulse"></i>');
    //     const $promise = $.ajax({
    //       url: products.ajaxUrl,
    //       method: 'post',
    //       dataType: 'json',
    //       data: {'json': jsonData, 'security': products.nonce, 'action': 'addToBagQuickview'}
    //     });

    //     $promise.done((response, textStatus, jqXhr) => {
    //       if (response.status === 'success') {
    //         $(target).html('Added!');
    //         const currentShoppingBagTotal = parseInt($('.main-nav-shopping-cart-button>a').text());
    //         $('.main-nav-shopping-cart-button > a').html(currentShoppingBagTotal+parseInt(response.data.quantityAdded));
    //         $('.header__mobile-menu__list-item.shopping-cart-button>a').html(currentShoppingBagTotal+parseInt(response.data.quantityAdded));
    //         setTimeout(() => {
    //           $(target).html('Add to Bag');
    //         },1000);
    //       }
    //     });

    //     $promise.fail((jqXhr, textStatus, errorThrown) => {
    //       // console.log(jqXhr);
    //       // console.log(textStatus);
    //       // console.log(errorThrown);
    //     });
    //   }
    // });

    // add the code to detect if we need to prepend Pro pricing label to bulk price
    if ($('.product-landing__post-meta > .woocommerce-Price-amount:first-child').length && (products.userRole === 'pro')) {
      $('.product-landing__post-meta > .woocommerce-Price-amount:first-child, .product-landing__post-meta > ins > .woocommerce-Price-amount:first-child').each((i, e) => {
        const $price = $(e).clone();
        $price.find('.woocommerce-Price-currencySymbol').remove();
        const priceValue = parseFloat($price.html());
        // $(e).closest('.product-landing__post-meta').html(`<p>Pro Pricing starts at $${(priceValue-(priceValue*0.50)).toFixed(2)}</p>`); // Comment out pro pricing 2020-10-22 per Trish's request
        $(e).closest('.product-landing__post-meta').html(`<p></p>`);
      }).promise().done(() => {
        // matchHeight.js
        $grid.isotope();
      });
    } else {
      $grid.isotope();
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/postTypeArchiveProduct.js